import { getStorage } from "firebase/storage";
import firebase from 'firebase/compat';
import { encryptDecrypt } from "./layout/utils";
import { getDatabase } from "firebase/database";
const jwt = require("jsonwebtoken");


/**
 * Middleware to verify the JWT token in the request's "Authorization" header.
 * @param {Request} req - Express request object.
 * @param {Response} res - Express response object.
 * @param {Function} next - Callback to pass control to the next middleware.
 */

/**
 * Fetches Firebase configuration from the backend API.
 * @returns {Promise<string>} A base64 and JWT encoded Firebase configuration.
 */
const fetchFirebaseConfig = () => {
    try {
        let token = "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"
        //decode token from base64
        const decodedToken = atob(token);
        // console.log("decodedToken", decodedToken);
        //decrypt token
        const decryptedToken = encryptDecrypt("decrypt", decodedToken);
        // console.log("decryptedToken", decryptedToken);
        //received jwt token in decryptedToken decode that using hs512 algorithm
        const decoded = jwt.decode(decryptedToken, { complete: true });
        // console.log("decoded", decoded);
        //delete exp and iat from payload
        delete decoded.payload.exp;
        delete decoded.payload.iat;
        return decoded.payload;

        // if (response.status === 200) {
        // return atob(data);
        // } else {
        //     throw new Error("Failed to fetch Firebase configuration");
        // }
    } catch (error) {
        throw error;
    }
};

/**
 * Initializes Firebase and returns Firestore and Storage instances.
 * @returns {Promise<{ db: Firestore, storage: Storage } | null>} Firebase services or null if an error occurs.
 */
const initializeFirebase = () => {
    try {

        const firebaseConfig = fetchFirebaseConfig();

        // console.log("firebaseConfig", firebaseConfig);
        // const key = firebaseConfig;

        const app = firebase.initializeApp(firebaseConfig);
        const db = firebase.firestore();
        const storage = getStorage(app);
        const fb = firebase;
        const googleProvider = new firebase.auth.GoogleAuthProvider();
        const database = getDatabase(app);
        const ref = firebase.database().ref();
        const firebaseAuth = firebase.auth;
        const storageConnection = firebase.storage().ref();

        // console.log("db-------", db, storageConnection);
        return { db, storage, fb, googleProvider, database, ref, firebaseAuth, storageConnection };
    } catch (error) {
        // console.error("Error initializing Firebase:", error);
        return null;
    }
};


const firebaseServices = initializeFirebase();



export default firebaseServices;

